import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Auth/Login';
import Register from './pages/Auth/Register';
import Dashboard from './pages/Dashboard/Dashboard';

// Import dengan ALIAS untuk menghindari webpack conflict
import ListeningPage from './pages/Exam/AudioListening';
import StructurePage from './pages/Exam/Structure';
import ReadingPage from './pages/Exam/Reading';
import ResultPage from './pages/Exam/Result';

import PanelAdmin from './pages/AdminPanel';
import ProtectedRoute from './components/ProtectedRoute';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import VerifyEmail from './components/VerifyEmail';

function App() {
  return (
    <Routes>
      {/* === PUBLIC AUTH ROUTES === */}
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/verify-email" element={<VerifyEmail />} />

      {/* === USER DASHBOARD === */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />

      {/* === ADMIN PANEL === */}
      <Route
        path="/admin"
        element={
          <ProtectedRoute allowedRoles={['admin', 'super_admin']}>
            <PanelAdmin />
          </ProtectedRoute>
        }
      />

      {/* === EXAM ROUTES === */}
      <Route
        path="/exam/listening"
        element={
          <ProtectedRoute>
            <ListeningPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/exam/structure"
        element={
          <ProtectedRoute>
            <StructurePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/exam/reading"
        element={
          <ProtectedRoute>
            <ReadingPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/exam/result"
        element={
          <ProtectedRoute>
            <ResultPage />
          </ProtectedRoute>
        }
      />

      {/* === DEFAULT & FALLBACK === */}
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default App;
